type Props = { total: number; current: number }

export function ProgressBar({ total, current }: Props) {
  return (
    <div className="progress">
      {Array.from({ length: total }, (_, i) => (
        <div key={i} className={i < current ? 'on' : ''} />
      ))}
    </div>
  )
}
